var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CalcOutputChangeRequestEvent_1;
import { Utils } from '@symon-ai/wisepipe-common';
import { DateConverter, JSON, JsonConverter, JsonSchema } from '@symon-ai/wisepipe-serialize';
export var ChangeRequestStatus;
(function (ChangeRequestStatus) {
    ChangeRequestStatus["Pending"] = "pending";
    ChangeRequestStatus["Accepted"] = "accepted";
    ChangeRequestStatus["Rejected"] = "rejected";
    ChangeRequestStatus["Staged"] = "staged";
    ChangeRequestStatus["Withdrawn"] = "withdrawn"; // if a stage request doesnt contain any changes requiring a change request, withdraw it and apply changes immediately
})(ChangeRequestStatus || (ChangeRequestStatus = {}));
export var ChangeRequestOperation;
(function (ChangeRequestOperation) {
    ChangeRequestOperation["Put"] = "put";
    ChangeRequestOperation["BatchPut"] = "batchPut";
    ChangeRequestOperation["BatchPatch"] = "batchPatch";
    ChangeRequestOperation["Delete"] = "delete";
    ChangeRequestOperation["BatchDelete"] = "batchDelete";
    ChangeRequestOperation["PutAll"] = "putAll";
    ChangeRequestOperation["ToolsUpdate"] = "toolsUpdate";
    ChangeRequestOperation["ToolsUpdateByElementIDs"] = "toolsUpdateByElementIDs";
})(ChangeRequestOperation || (ChangeRequestOperation = {}));
const schema = {
    $id: 'urn:wisepipe-common-pipe:CalcOutputChangeRequestEvent',
    type: 'object',
    properties: {
        requestID: { type: 'string', uid: 9 },
        orgID: { type: 'string', format: 'uuid' },
        pipeID: { type: 'string', uid: 10 },
        requestedChanges: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:CalcOutputChangeRequest' } },
        initiatedAt: { type: 'string', format: 'date-time' },
        expireAt: { type: 'string', format: 'date-time' }, // expireAt only exists after incentives has retrieved the request
        status: { type: 'string', enum: Object.values(ChangeRequestStatus) },
        respondedAt: { type: 'string', format: 'date-time' }
    },
    required: ['requestID', 'orgID', 'pipeID', 'requestedChanges', 'status', 'initiatedAt']
};
let CalcOutputChangeRequestEvent = CalcOutputChangeRequestEvent_1 = class CalcOutputChangeRequestEvent {
    constructor(requestID, orgID, pipeID, requestedChanges, status, initiatedAt, expireAt, respondedAt) {
        this.requestID = requestID;
        this.orgID = orgID;
        this.pipeID = pipeID;
        this.requestedChanges = requestedChanges;
        this.status = status;
        this.initiatedAt = initiatedAt;
        if (expireAt !== undefined)
            this.expireAt = expireAt;
        if (respondedAt !== undefined)
            this.respondedAt = respondedAt;
        JSON.validate(this, CalcOutputChangeRequestEvent_1);
    }
    static newID() {
        return Utils.newID();
    }
    static bufferID(base64FileID) {
        return Utils.base64StringToBuffer(base64FileID);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], CalcOutputChangeRequestEvent.prototype, "initiatedAt", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], CalcOutputChangeRequestEvent.prototype, "expireAt", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], CalcOutputChangeRequestEvent.prototype, "respondedAt", void 0);
CalcOutputChangeRequestEvent = CalcOutputChangeRequestEvent_1 = __decorate([
    JsonSchema(schema)
], CalcOutputChangeRequestEvent);
export { CalcOutputChangeRequestEvent };
//# sourceMappingURL=calcOutputChangeRequestEvent.js.map